<script>
    export let isMenuOpen;
    export let toggleMenu;
    export let user_defined_config;
    export let menuItems;
    export let getNumberOfMenuItemsByParentId;

    const urlClicked = () => {
        toggleMenu();
    }
</script>


{#if !isMenuOpen}
    <button class="hamburger-menu" on:click={toggleMenu} aria-label="Toggle menu"><i class="fas fa-bars"></i></button>
{/if}
{#if isMenuOpen}
    <div class="mobile-menu">
        <div class="mobile-menu-header">
            <div>
                <h2 class="title-mobile main-title-mobile">Heimat und Genuss</h2>
                <h3 class="title-mobile sub-title-mobile">Dorfladen Gungolding</h3>
            </div>
            <button class="hamburger-menu close-menu" on:click={toggleMenu} aria-label="Close menu">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="row info-box-mobile">
            {#await user_defined_config}
            {:then configdata}
                <div class="col-6 text-start">
                    <p>
                        <strong><i class="fas fa-home"></i> Adresse:</strong>
                        <br>
                        <span class="d-block">{configdata.ADDRESS}</span>
                    </p>
                </div>
                <div class="col-6 text-end">
                    <p>
                        <strong><i class="far fa-clock"></i> Öffnungszeiten:</strong>
                        <br>
                        <span class="d-block">{configdata.OPENING_HOURS}</span>
                    </p>
                </div>
            {/await}
        </div>

        {#await menuItems}
        {:then data}
            <nav class="mobile-navbar">
                <ul class="mobile-nav-list">
                    {#each data as item}
                        {#if item.mparent === null}
                            <li class="mobile-nav-item">
                                <a class="mobile-nav-link" href="/site/{item.urlname}-m-{item.mid}" on:click={urlClicked}>{@html item.mname}</a>
                                {#if getNumberOfMenuItemsByParentId(data, item.mid) > 0}
                                    <ul class="mobile-sub-nav-list">
                                        {#each data as subitem}
                                            {#if subitem.mparent === item.mid}
                                                <li class="mobile-sub-nav-item">
                                                    <a class="mobile-sub-nav-link" href="/site/{subitem.urlname}-m-{subitem.mid}" on:click={urlClicked}>{@html subitem.mname}</a>
                                                </li>
                                            {/if}
                                        {/each}
                                    </ul>
                                {/if}
                            </li>
                        {/if}
                    {/each}
                </ul>
            </nav>
        {/await}
    </div>
{/if}

<style>
    /* Mobile-Styling */
    .hamburger-menu {
        display: none;
        background: #32502e;
        border: none;
        color: white;
        padding: 10px 15px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 1.2rem;
        position: absolute;
        top: 15px;
        right: 15px;
    }

    .mobile-menu {
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        /*background: white;*/
        background-color: #f0f0f0; /* Helle Hintergrundfarbe */
        background-image: radial-gradient(circle, #eaeaea 1px, transparent 1px);
        background-size: 10px 10px; /* Größe der Rauschmuster */
        box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
        padding: 20px;
        z-index: 1000;
        overflow-y: auto;
    }

    .mobile-menu-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ddd;
        padding-bottom: 10px;
        margin-bottom: 15px;
    }

    .title-mobile {
        font-family: 'Dancing Script', cursive; /* Verspielte, handschriftliche Schrift */
    }

    .main-title-mobile {
        font-weight: bold;
        font-size: 1.85em;
    }

    .sub-title-mobile {
        color: #93c12a;
    }

    .close-menu {
        background: #e63946;
        color: white;
    }

    .mobile-navbar {
        margin-top: 15px;
    }

    .mobile-nav-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .mobile-nav-item {
        margin-bottom: 10px;
    }

    .mobile-nav-link {
        display: block;
        /*padding: 10px;*/
        /*background: #32502e;*/
        /*color: white;*/
        /*text-decoration: none;*/
        /*border-radius: 4px;*/

        text-decoration: none;
        padding: 8px 14px;
        color: #4a3f35; /* Dunkler Braunton passend zum Logo */
        background: rgba(255, 255, 255, 0.85); /* Heller, warmer Hintergrund */
        border: 2px solid #4a3f35; /* Dunkle Kontur */
        border-radius: 8px;
        box-shadow: 3px 3px 0px #4a3f35;
    }

    .mobile-sub-nav-list {
        list-style: none;
        padding-left: 20px;
        margin-top: 15px;
    }

    .mobile-sub-nav-item {
        margin-bottom: 15px;
    }

    .mobile-sub-nav-link {
        color: #4a3f35;
        text-decoration: none;
    }

    .info-box-mobile {
        padding: 5px;
        font-size: 0.82em; /* Kleinere Schriftgröße */
        margin-top: 10px; /* Etwas Abstand */
        white-space: pre-line;
        height: auto;
    }

    @media (max-width: 1200px) {
        .hamburger-menu {
            display: block;
            z-index: 1100;
        }
    }
</style>
